import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { mergeDeep } from '../utils/deep-merge.utils';

export const BASE_API_URL = new InjectionToken<string>('Base Api Url');

export const BASE_API_OPTIONS = new InjectionToken<string>('Base Api Options');

@Injectable({ providedIn: 'root' })
export class BaseApiService {
  constructor(
    protected httpClient: HttpClient,
    @Inject(BASE_API_URL) protected baseApiUrl: string = '',
    @Inject(BASE_API_OPTIONS) @Optional() protected baseOptions: Object = {}
  ) {}

  get<T>(endpoint: string, rawOptions?: Object): Observable<T> {
    const options: Object = mergeDeep({}, this.baseOptions, rawOptions);
    return this.httpClient.get<T>(`${this.baseApiUrl}${endpoint}`, options);
  }

  post<T>(endpoint: string, body: any, rawOptions?: Object): Observable<T> {
    const options: Object = mergeDeep({}, this.baseOptions, rawOptions);
    return this.httpClient.post<T>(
      `${this.baseApiUrl}${endpoint}`,
      body,
      options
    );
  }

  put<T>(endpoint: string, body: any, rawOptions?: Object): Observable<T> {
    const options: Object = mergeDeep({}, this.baseOptions, rawOptions);
    return this.httpClient.put<T>(
      `${this.baseApiUrl}${endpoint}`,
      body,
      options
    );
  }

  delete<T>(endpoint: string, rawOptions?: Object): Observable<T> {
    const options: Object = mergeDeep({}, this.baseOptions, rawOptions);
    return this.httpClient.delete<T>(`${this.baseApiUrl}${endpoint}`, options);
  }
}
